import React, { } from 'react';
import { Tooltip } from 'antd';


const DcrFieldNewValueMapResolver = ({ value }) => value.newValueMapped ? <Tooltip title={value.newValue}>{value.newValueMapped}</Tooltip> : value.newValue;

export default DcrFieldNewValueMapResolver;
